export default "/images/a05ac19a05950850574fefe3a42a629b.jpg";